import { authHeader } from "../../screens/tenants/redux/authHeaders"
import Constant from "../../screens/tenants/redux/constant"
import { handleApiResponse } from "../../screens/tenants/redux/handleApiResponse";
const handleResponse = handleApiResponse.handleResponse;

export const maintenanceService: any = {}

/* ===========================================
   GET ROOM TYPES
=========================================== */

maintenanceService.getRoomTypes = async () => {
  const headers = {
    ...(await authHeader()),
    'Content-Type': 'application/json',
  }

  const requestOptions = {
    method: 'GET',
    headers,
  }

  return fetch(
    `${Constant.API_URL}/maintenance/room_types`,
    requestOptions
  ).then(handleResponse)
}
maintenanceService.getCatogoriesTypes = async () => {
    const headers = {
      ...(await authHeader()),
      'Content-Type': 'application/json',
    }
  
    const requestOptions = {
      method: 'GET',
      headers,
    }
  
    return fetch(
      `${Constant.API_URL}/maintenance/categories`,
      requestOptions
    ).then(handleResponse)
  }
/* ===========================================
   GET FLOWS
=========================================== */

maintenanceService.getFlows = async (params: any) => {
  const headers = {
    ...(await authHeader()),
    'Content-Type': 'application/json',
  }

  const query = new URLSearchParams(params).toString()

  const requestOptions = {
    method: 'GET',
    headers,
  }
  console.log("params",params)
let URL = params?.flow_id ?`${Constant.API_URL}/maintenance/flow/active/${params?.flow_id}?${query}`: `${Constant.API_URL}/maintenance/flow/active?${query}`
  return fetch(
    URL ,
    requestOptions
  ).then(handleResponse)
}

/* ===========================================
   ADD ISSUE
=========================================== */

maintenanceService.addIssue = async (payload: any) => {
  const headers = {
    ...(await authHeader()),
    'Content-Type': 'application/json',
  }

  const { openflow_id, ...body } = payload

  const requestOptions = {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  }

  return fetch(
    `${Constant.API_URL}/maintenance/issues?flow_id=${openflow_id}`,
    requestOptions
  ).then(handleResponse)
}
maintenanceService.editIssue = async (payload: any) => {
  const headers = {
    ...(await authHeader()),
    'Content-Type': 'application/json',
  }

  const { open_flow_maintenance_issue_id, ...body } = payload

  const requestOptions = {
    method: 'PUT',
    headers,
    body: JSON.stringify(body),
  }

  return fetch(
    `${Constant.API_URL}/maintenance/issues/${open_flow_maintenance_issue_id}`,
    requestOptions
  ).then(handleResponse)
}

/* ===========================================
   UPDATE ISSUE
=========================================== */

maintenanceService.archiveProject = async (payload: any) => {
  const headers = {
    ...(await authHeader()),
    'Content-Type': 'application/json',
  }

  const { id, ...body } = payload

  const requestOptions = {
    method: 'PUT',
    headers,
    body: JSON.stringify(body),
  }

  return fetch(
    `${Constant.API_URL}/maintenance/archive_project/${id}`,
    requestOptions
  ).then(handleResponse)
}


maintenanceService.unarchiveProject = async (payload: any) => {
  const headers = {
    ...(await authHeader()),
    'Content-Type': 'application/json',
  }

  const { id, ...body } = payload

  const requestOptions = {
    method: 'PUT',
    headers,
    body: JSON.stringify(body),
  }

  return fetch(
    `${Constant.API_URL}/maintenance/unarchive_project/${id}`,
    requestOptions
  ).then(handleResponse)
}

maintenanceService.updateProject = async (payload: any) => {
  const headers = {
    ...(await authHeader()),
    'Content-Type': 'application/json',
  }

  const { project_id, ...body } = payload

  const requestOptions = {
    method: 'PUT',
    headers,
    body: JSON.stringify(body),
  }

  return fetch(
    `${Constant.API_URL}/maintenance/project/${project_id}`,
    requestOptions
  ).then(handleResponse)
}
maintenanceService.updateIssue = async (payload: any) => {
  const headers = {
    ...(await authHeader()),
    'Content-Type': 'application/json',
  }

  const { id, ...body } = payload

  const requestOptions = {
    method: 'PUT',
    headers,
    body: JSON.stringify(body),
  }

  return fetch(
    `${Constant.API_URL}/maintenance/issues/${id}`,
    requestOptions
  ).then(handleResponse)
}

    maintenanceService.summarizeRequest = async (id: any) => {
      const headers = {
        ...(await authHeader()),
        'Content-Type': 'application/json',
      }
    
      const requestOptions = {
        method: 'POST',
        headers,
        body:null,
      }
       const endpoint = `${Constant.API_URL}/maintenance/issues/${id}/summarize`
      return fetch(
        endpoint,
        requestOptions
      ).then(handleResponse)
    }

    maintenanceService.createProject = async (id: any,body) => {
      const headers = {
        ...(await authHeader()),
        'Content-Type': 'application/json',
      }
    
      const requestOptions = {
        method: 'POST',
        headers,
        body:JSON.stringify(body),
      }
       const endpoint = `${Constant.API_URL}/maintenance/project/${id}`
      return fetch(
        endpoint,
        requestOptions
      ).then(handleResponse)
    }  
    maintenanceService.getProjects = async (params: any) => {
      const headers = {
        ...(await authHeader()),
        'Content-Type': 'application/json',
      }
    
      const query = new URLSearchParams(params).toString()
    
      const requestOptions = {
        method: 'GET',
        headers,
      }
      console.log("params",params)
    let URL =  params.status=="archived"?`${Constant.API_URL}/maintenance/archived_projects?${query}`:  params?.flow_id ?`${Constant.API_URL}/maintenance/project/${params?.flow_id}`: `${Constant.API_URL}/maintenance/projects?${query}`
      return fetch(
        URL ,
        requestOptions
      ).then(handleResponse)
    }

    maintenanceService.updateIssueStatus = async (payload: any) => {
      const headers = {
        ...(await authHeader()),
        'Content-Type': 'application/json',
      }
    
      const { issue_id, ...body } = payload
    
      const requestOptions = {
        method: 'PUT',
        headers,
        body: JSON.stringify(body),
      }
      const endpoint = `maintenance/issues/${issue_id}/status`

      return fetch(
        `${Constant.API_URL}/${endpoint}`,
        requestOptions
      ).then(handleResponse)
    }
    